module.exports = __webpack_public_path__ + "img/expend.f07deab4.png";